import { db } from '../../../config/firebase-config';
import {
    getDocs,
    getDoc,
    collection,
    doc,
    updateDoc,
    serverTimestamp,
    setDoc,
    arrayUnion
} from 'firebase/firestore';
import { ROLES } from '../../../constants/roles';
import { defaultForm, defaultType } from '../../../constants/form-type';
import { STATUS } from '../../../constants/form-status';

const TABLE_NAME = "SubmittedForms";
const FIELD = {
    SELECTED_TEMPLATES: "SelectedTemplates"
}

const submittedFormCollectionRef = collection(db, TABLE_NAME);

//Get All Items
export const getAllSubmittedForms = async (id, role) => {
    try {
        const data = await getDocs(submittedFormCollectionRef);

        const filteredData = data.docs
            .filter(doc => filterByRole(doc.data(), id, role))
            .map(doc => ({
                ...doc.data(),
                Id: doc.id
            }));
            
        return filteredData;
    } catch (error) {
        throw error;
    }
}

const filterByRole = (data, id, role) => {
    if (role === ROLES.HQ) {
        return data
    } else {
        const buyerAssociateRepresentative1 = parseInt(data.Values.mainValues.buyerAssociate1Name_ID);
        const buyerAssociateRepresentative2 = parseInt(data.Values.mainValues.buyerAssociate2Name_ID);
        const sellerAssociateRepresentative1 = parseInt(data.Values.mainValues.sellerAssociate1Name_ID);
        const sellerAssociateRepresentative2 = parseInt(data.Values.mainValues.sellerAssociate2Name_ID);
        const tenantAssociateRepresentative1 = parseInt(data.Values.mainValues.tenantAssociate1Name_ID);
        const tenantAssociateRepresentative2 = parseInt(data.Values.mainValues.tenantAssociate2Name_ID);
        const landlordAssociateRepresentative1 = parseInt(data.Values.mainValues.landlordAssociate1Name_ID);
        const landlordAssociateRepresentative2 = parseInt(data.Values.mainValues.landlordAssociate2Name_ID);

        if(data.Form === defaultForm[1] && data.Type === defaultType[0]){ //BDC Sales
            
            return data.Status !== STATUS.DRAFT
            && 
                (
                    data.Agent?.id === id ||
                    data.CreatedBy?.id === id ||
                    data.ModifiedBy?.id === id ||
                    (buyerAssociateRepresentative1 && buyerAssociateRepresentative1 === id) ||
                    (buyerAssociateRepresentative2 && buyerAssociateRepresentative2 === id) ||
                    (sellerAssociateRepresentative1 && sellerAssociateRepresentative1 === id) ||
                    (sellerAssociateRepresentative2 && sellerAssociateRepresentative2 === id) ||
                    (tenantAssociateRepresentative1 && tenantAssociateRepresentative1 === id) ||
                    (tenantAssociateRepresentative2 && tenantAssociateRepresentative2 === id) ||
                    (landlordAssociateRepresentative1 && landlordAssociateRepresentative1 === id) ||
                    (landlordAssociateRepresentative2 && landlordAssociateRepresentative2 === id)

                )
        }else{
            if(
                data.Agent?.id === id || 
                data.CreatedBy?.id === id || 
                data.ModifiedBy?.id === id ||
                data.UserDetails?.id === id ||
                (buyerAssociateRepresentative1 && buyerAssociateRepresentative1 === id) ||
                (buyerAssociateRepresentative2 && buyerAssociateRepresentative2 === id) ||
                (sellerAssociateRepresentative1 && sellerAssociateRepresentative1 === id) ||
                (sellerAssociateRepresentative2 && sellerAssociateRepresentative2 === id) ||
                (tenantAssociateRepresentative1 && tenantAssociateRepresentative1 === id) ||
                (tenantAssociateRepresentative2 && tenantAssociateRepresentative2 === id) ||
                (landlordAssociateRepresentative1 && landlordAssociateRepresentative1 === id) ||
                (landlordAssociateRepresentative2 && landlordAssociateRepresentative2 === id)
            )  { 
                return data
            } 
        }

    }
}

//Get Doc by DocID
export const getSubmittedFormByID = async (docID, id, role) => {
    const docRef = doc(db, TABLE_NAME, docID);
    try {
        const docSnap = await getDoc(docRef);
        const data = docSnap.data();

        const buyerAssociateRepresentative1 = parseInt(data.Values.mainValues.buyerAssociate1Name_ID);
        const buyerAssociateRepresentative2 = parseInt(data.Values.mainValues.buyerAssociate2Name_ID);
        const sellerAssociateRepresentative1 = parseInt(data.Values.mainValues.sellerAssociate1Name_ID);
        const sellerAssociateRepresentative2 = parseInt(data.Values.mainValues.sellerAssociate2Name_ID);
        const tenantAssociateRepresentative1 = parseInt(data.Values.mainValues.tenantAssociate1Name_ID);
        const tenantAssociateRepresentative2 = parseInt(data.Values.mainValues.tenantAssociate2Name_ID);
        const landlordAssociateRepresentative1 = parseInt(data.Values.mainValues.landlordAssociate1Name_ID);
        const landlordAssociateRepresentative2 = parseInt(data.Values.mainValues.landlordAssociate2Name_ID);

        if (
            role === ROLES.HQ ||
            data.CreatedBy?.id === id || 
            data.ModifiedBy?.id === id || 
            data.Agent?.id === id ||
            (buyerAssociateRepresentative1 && buyerAssociateRepresentative1 === id) ||
            (buyerAssociateRepresentative2 && buyerAssociateRepresentative2 === id) ||
            (sellerAssociateRepresentative1 && sellerAssociateRepresentative1 === id) ||
            (sellerAssociateRepresentative2 && sellerAssociateRepresentative2 === id) ||
            (tenantAssociateRepresentative1 && tenantAssociateRepresentative1 === id) ||
            (tenantAssociateRepresentative2 && tenantAssociateRepresentative2 === id) ||
            (landlordAssociateRepresentative1 && landlordAssociateRepresentative1 === id) ||
            (landlordAssociateRepresentative2 && landlordAssociateRepresentative2 === id)
        ) {
        return data;
        }
        return {}
    } catch (error) {
        throw error;
    }
}

//Add new Item
export const addNewSubmittedForm = async (docData) => {
    try {
        // const data = await addDoc(submittedFormCollectionRef, docData);
        // return data;
        const serverTime = serverTimestamp();

        const docRef = doc(submittedFormCollectionRef, docData.TransactionId);

        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            // Document already exists,
            docData.Created = docSnap.data().Created ? docSnap.data().Created : serverTime;
            docData.Modified = serverTime;
            docData.CreatedBy = docSnap.data().CreatedBy ? docSnap.data().CreatedBy : docData.CreatedBy;
            docData.ModifiedBy = docData.ModifiedBy;
        } else {
            // Document does not exist, 
            docData.Created = serverTime;
            docData.Modified = serverTime;
            docData.CreatedBy = docData.CreatedBy;
            docData.ModifiedBy = docData.CreatedBy;
        }

        // Set the document data
        await setDoc(docRef, docData);

        return docData
    } catch (error) {
        throw error;
    }
}

//Update Item
export const updateSubmittedForm = async (docID, docData) => {
    try {
        const serverTime = serverTimestamp();

        const docRef = doc(db, TABLE_NAME, docID);

        docData.Modified = serverTime;
        docData.ModifiedBy = docData.ModifiedBy;

        const data = await updateDoc(docRef, docData);

        return data;
    } catch (error) {
        throw error;
    }
}

export const updateSelectedTemplates = async (documentID, data) => {

    const documentRef = doc(submittedFormCollectionRef, documentID);

    try {
        await updateDoc(documentRef, {
            [FIELD.SELECTED_TEMPLATES]: arrayUnion(data)
        });

    } catch (error) {
        throw error;
    }
}
